<template>
  <div class="table-container">
    <public-table
      addPerm="Market.Application.Package.Create"
      :onAdd="
        () => {
          editPackage = defaultPackageVlue;
          showEditPackage = true;
        }
      "
      :column="column"
      :tableData="packages"
    >
      <template v-slot:name="{ row }">
        {{ row.name }}
        <el-tag
          style="margin-left: 5px"
          v-if="row.isTrial"
          type="success"
          size="mini"
          >试用</el-tag
        >
      </template>
      <template v-slot:packageType="{ row }">
        {{
          row.packageType === 'free'
            ? '免费'
            : row.packageType === 'pay'
            ? '付费'
            : '商业咨询'
        }}
      </template>
      <template v-slot:version="{ row }">
        {{ row.packageType !== 'business' ? row.version : '-' }}
      </template>

      <template v-slot:billtype="{ row }">{{
        row.packageType !== 'pay' ? '-' : '服务时长'
      }}</template>
      <template v-slot:billCycle="{ row }">{{
        row.packageType === 'pay' ? showBillCycle(row.billCycle) : '-'
      }}</template>
      <template v-slot:price="{ row }">
        {{ row.packageType === 'pay' ? row.price + '元' : '-' }}
      </template>
      <template v-slot:enable="{ row }">
        <span v-if="row.enable" style="color: #13ce66">可用</span>
        <span v-if="!row.enable" style="color: #ff4949">禁用</span>
      </template>
      <template v-slot:createTime="{ row }">{{
        row.createTime ? timetrans(row.createTime) : '-'
      }}</template>
      <template v-slot:operation="{ row }">
        <el-button
          size="mini"
          type="text"
          v-permit="'Market.Application.Package.Update'"
          @click="handleEditPackage(row)"
          >编辑</el-button
        >
        <el-button
          size="mini"
          type="text"
          v-permit="'Market.Application.Package.Update'"
          @click="handleConfigEnv(row)"
          >环境变量</el-button
        >
        <el-button
          size="mini"
          type="text"
          v-permit="'Market.Application.Package.Delete'"
          @click="deletePackage(row)"
          style="margin-left: 0px"
          >删除</el-button
        >
      </template>
    </public-table>
    <EditAppPackage
      v-if="showEditPackage"
      :marketID="marketID"
      :appPackage="editPackage"
      :productID="productID"
      :dialogVisible="showEditPackage"
      :onSuccess="editPackageSuccess"
      :onClose="() => ((showEditPackage = false), (editPackage = null))"
    ></EditAppPackage>
    <env-config-dialog
      :visible.sync="showEnvConfig"
      :marketID="marketID"
      :productID="productID"
      :packageID="currentPackageID"
      @saved="handleEnvConfigSaved"
    />
  </div>
</template>
<script>
import { getProductPackages, deleteProductPackage } from '@/api/product';
import { timetrans } from '@/utils/validate';
import { errorHandle } from '../../../../utils/error';
import EditAppPackage from './editAppPackage';
import EnvConfigDialog from './EnvConfigDialog.vue';
export default {
  name: 'ProductPackageList',
  props: {
    appDetail: {
      type: Object
    },
    marketID: {
      type: String
    }
  },
  components: { EditAppPackage, EnvConfigDialog },
  data() {
    const defaultPackageVlue = {
      items: [{ name: '', showName: '', value: '' }],
      description: '',
      billtype: '',
      billCycle: '',
      version: '',
      enable: true,
      price: 0,
      isTrial: false,
      enableReview: false,
      appKeyID: '' // 添加模板ID字段
    };
    return {
      productID: this.$route.params.productID,
      timetrans: timetrans,
      showEditPackage: false,
      showEnvConfig: false,
      currentPackageID: '',
      packages: [],
      editPackage: defaultPackageVlue,
      defaultPackageVlue,
      column: [
        {
          prop: 'name',
          label: '名称',
          align: 'left',
          scopeStatus: true
        },
        {
          prop: 'packageType',
          label: '套餐类型',
          scopeStatus: true
        },
        {
          prop: 'version',
          label: '所属版本',
          scopeStatus: true
        },
        {
          prop: 'enable',
          label: '状态',
          scopeStatus: true
        },
        {
          prop: 'billtype',
          label: '计费类型',
          scopeStatus: true
        },
        {
          prop: 'billCycle',
          label: '计费周期',
          scopeStatus: true
        },
        {
          prop: 'price',
          label: '单价',
          scopeStatus: true
        },
        {
          prop: 'createTime',
          label: '创建时间',
          width: '170px',
          scopeStatus: true
        },
        {
          prop: 'operation',
          label: '操作',
          width: '150px',
          scopeStatus: true
        }
      ]
    };
  },
  created() {
    this.fetchProductPackageList();
  },
  methods: {
    showBillCycle(data) {
      switch (data) {
        case 'year':
          return '年度';
        case 'month':
          return '月度';
        case 'week':
          return '周';
        case 'quarter':
          return '季度';
        default:
          return '';
      }
    },
    fetchProductPackageList() {
      getProductPackages({ marketID: this.marketID, productID: this.productID })
        .then((res) => {
          this.Loading = false;
          this.packages = res.packages || [];
        })
        .catch((err) => {
          this.Loading = false;
          if (err.code == 404) {
            this.$router.push({
              name: 'productManage'
            });
          }
        });
    },
    deletePackage(row) {
      this.$confirm('是否要删除该套餐?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onDeleteProductPackage(row);
      });
    },
    onDeleteProductPackage(row) {
      deleteProductPackage({
        marketID: this.marketID,
        productID: this.productID,
        packageID: row.packageID
      })
        .then((res) => {
          this.Loading = false;
          this.$message.success('删除成功');
          this.fetchProductPackageList();
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    handleEditPackage(row = {}) {
      if (row.items && row.items.length === 0) {
        row.items = this.defaultPackageVlue.items;
      }
      this.editPackage = JSON.parse(JSON.stringify(row));
      this.showEditPackage = true;
    },
    editPackageSuccess() {
      this.showEditPackage = false;
      this.editPackage = null;
      this.fetchProductPackageList();
    },
    handleConfigEnv(row) {
      this.currentPackageID = row.packageID;
      this.showEnvConfig = true;
    },
    handleEnvConfigSaved() {
      this.$message.success('环境变量配置已保存');
    },
    showPackageName(row) {
      if (row.isTrial) {
        return `${row.name}(试用套餐)`;
      }
      return row.name;
    }
  }
};
</script>
<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/views/storeManage/productManage/components/appPackage.vue